import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { OrganizationProvider } from './context/OrganizationContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { AppLayout } from './components/layout/AppLayout';
import { ClientLayout } from './components/layout/ClientLayout';
import Login from './screens/Login';
import Register from './screens/Register';
import ForgotPassword from './screens/ForgotPassword';
import ResetPassword from './screens/ResetPassword';
import TwoFactorRequired from './screens/TwoFactorRequired';
import ClientDashboard from './screens/ClientDashboard';
import DataAcquisition from './screens/DataAcquisition';
import DataReview from './screens/DataReview';
import CustomerIdentification from './screens/CustomerIdentification';
import Reconciliation from './screens/Reconciliation';
import QuickBooksCallback from './screens/QuickBooksCallback';
import Admin from './screens/Admin';
import Profile from './screens/Profile';
import JobHistory from './screens/JobHistory';

function App() {
  return (
    <AuthProvider>
      <OrganizationProvider>
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/qb-callback" element={<QuickBooksCallback />} />

            {/* 2FA setup - protected but exempt from 2FA check */}
            <Route element={<ProtectedRoute skip2FACheck />}>
              <Route path="/setup-2fa" element={<TwoFactorRequired />} />
            </Route>

            {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
              <Route element={<AppLayout />}>
                <Route path="/" element={<ClientDashboard />} />
                <Route path="/dashboard" element={<Navigate to="/" replace />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/job-history" element={<JobHistory />} />

                {/* Client routes with ClientLayout */}
                <Route path="/clients/:clientId" element={<ClientLayout />}>
                  <Route index element={<Navigate to="data-acquisition" replace />} />
                  <Route path="data-acquisition" element={<DataAcquisition />} />
                  <Route path="data-review" element={<DataReview />} />
                  <Route path="customer-identification" element={<CustomerIdentification />} />
                  <Route path="reconciliation" element={<Reconciliation />} />
                </Route>
              </Route>
            </Route>

            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </OrganizationProvider>
    </AuthProvider>
  );
}

export default App;
